import React, { forwardRef } from 'react'
import styled from 'styled-components'
import { UltraLight, Regular, MqTablet, Mono } from 'streamr-ui/css/consts'
import formatMoney from '~utils/formatMoney'

const Name = styled.div`
    font-family: ${Mono};
    font-size: 0.875rem;
    font-weight: ${Regular};
    letter-spacing: 1.5px;
    text-transform: uppercase;
    text-align: center;
    color: #ADADAD;

    @media ${MqTablet} {
        text-align: left;
    }
`

const Value = styled.div`
    font-size: 2rem;
    font-weight: ${UltraLight};
    line-height: 1em;
    margin-top: 1rem;
    text-align: center;
    color: #0C009A;
    letter-spacing: -0.5px;

    @media ${MqTablet} {
        font-weight: ${Regular};
        text-align: left;
        font-size: 1.5rem;
        margin-top: 0.75rem;
    }
`

const UnstyledAmountDisplay = forwardRef(function UnstyledAmountDisplay({ name, value, ...props }, ref) {
    return (
        <div {...props} ref={ref}>
            <Name>
                {name}
            </Name>
            <Value>
                {formatMoney(value).replace(/\s+/g, ',')}
            </Value>
        </div>
    )
})

const AmountDisplay = styled(UnstyledAmountDisplay)`
    & + & {
        margin-top: 3.75rem;
    }

    @media ${MqTablet} {
        & + & {
            margin-top: 2rem;
        }
    }
`

export default AmountDisplay
